export const convertBlobToImageSrc = (base64Blob: string, imageFormat: 'jpeg' | 'png') => `data:image/${imageFormat};base64,${base64Blob}`;
export const convertBlobToUrl = (base64Blob: string) => URL.createObjectURL(new Blob([base64Blob], { type: 'text/plain' }));
